import React, { useState } from 'react';
import LoginForm from './components/LoginForm';
import EmpresaForm from './components/EmpresaForm';
import EmpresaDetalle from './components/EmpresaDetalle';
import './estilos.css';

function App() {
  const [logueado, setLogueado] = useState(false);
  const [empresa, setEmpresa] = useState(null);

  if (!logueado) return <LoginForm onLogin={() => setLogueado(true)} />;
  if (!empresa) return <EmpresaForm onCreate={setEmpresa} />;
  return <EmpresaDetalle empresa={empresa} />;
}

export default App;